import type { FC } from 'react';
import { Form } from 'react-bootstrap';
import { TableRow, TableCell } from '@mui/material';
import type { Balance } from '@/types';
import { calculateTaskTotal } from '@utils/timesheetCalculations';

interface TimesheetRowProps {
  taskName: string;
  hours: string[];
  originalHours: string[];
  balance?: Balance;
  accrualAdjustment: number;
  onHourChange: (taskName: string, dayIndex: number, value: string) => void;
}

const TimesheetRow: FC<TimesheetRowProps> = ({ taskName, hours, originalHours, balance, accrualAdjustment, onHourChange }) => {
  const handleChange = (dayIndex: number, value: string) => {
    // Allow empty string or valid numbers
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      onHourChange(taskName, dayIndex, value);
    }
  };

  const taskTotal = calculateTaskTotal(hours);
  const originalWeekTotal = calculateTaskTotal(originalHours);
  const currentWeekTotal = taskTotal;

  // Calculate balance: initial + accrual - total + original_week_hours - current_week_hours + accrual_adjustment
  // This adjusts the backend's total (which includes the saved week) to reflect current edits
  // The accrual_adjustment accounts for changes in PTO/Comp accrual based on billable hours
  const balanceValue = balance
    ? balance.initial + balance.accrual - balance.total + originalWeekTotal - currentWeekTotal + accrualAdjustment
    : undefined;

  return (
    <TableRow>
      <TableCell className="sticky-col">{taskName}</TableCell>
      {hours.map((hour, index) => (
        <TableCell key={index} className="day-col">
          <Form.Control
            type="number"
            step="0.5"
            min="0"
            value={hour}
            onChange={(e) => handleChange(index, e.target.value)}
            className="hours"
          />
        </TableCell>
      ))}
      <TableCell className="total-col">
        <Form.Control
          type="number"
          value={taskTotal}
          disabled
          className="hours"
        />
      </TableCell>
      <TableCell className="balance-col">
        {balanceValue !== undefined && (
          <Form.Control
            type="number"
            value={balanceValue.toFixed(2)}
            disabled
            className="hours"
          />
        )}
      </TableCell>
    </TableRow>
  );
};

export default TimesheetRow;
